<app-header [selectedMenu]="MENU_PAGE.OPTIONS"></app-header>

<div class="container">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">

    <aside class="rope"></aside>
    <app-back-btn></app-back-btn>

    <section class="setting">

      <div class="inner wrap">


            <div class="setting-box">


              <article class="book-layout">

                <div class="book-layout-wrap type-page-list-none">

                  <div class="book-page-list">


                    <div class="book-page-group">
                      <div class="page-box">
                        <div class="page-content scroll-effect over-y">
                          <div class="list-wrap">
                          <ul>
                            <li *ngFor="let optionItem of optionItems">
                              <app-option-item class="item-box"
                                               [optionItem]="optionItem"></app-option-item>
                            </li>

                            <li>
                              <div class="item-box">
                                <div class="item-head-box">
                                  <div class="subject-box">책갈피 연동</div>
                                  <div class="sub-box">책갈피를 연동 하면, 다른 기기와 다른 브라우저에서도 동일한 책갈피를 볼 수 있습니다.</div>
                                </div>
                                <div class="item-body-box">
                                  <div *ngIf="this.snsInfo"
                                       class="bookmark-box">
                                    <div class="naver-logo {{ this.snsInfo.naver ? 'disconnect' : '' }}"
                                         (click)="onBookmarkSync($event)">
                                    </div>

                                    <!-- div class="bookmark-btn-box">
                                      <a class="bookmark-btn" (click)="onBookmarkSync($event)">
                                        <span class="bookmark-btn-text">{{ getSnsNaverTxt() }}</span>
                                      </a>
                                    </div -->

                                  </div>
                                </div>
                              </div>
                            </li>

<!--                            <li>-->
<!--                              <div class="item-box">-->
<!--                                <div class="item-head-box">-->
<!--                                  <div class="subject-box">듣고 배우는 한국어</div>-->
<!--                                  <div class="sub-box type-small">버전 {{ APP_VERSION }}</div>-->
<!--                                  &lt;!&ndash; a class="sub-box type-small"-->
<!--                                     (click)="onClearData($event)">저장된 데이터 지우기</a &ndash;&gt;-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </li>-->

                            <li>
                              <div class="item-box">

                                <div class="item-body-box" style="margin-top: 16px">
                                  <div class="licenses-btn-box">
                                    <a class="licenses-btn" [routerLink]="['/open-source']">
                                      오픈 소스 라이선스 고지
                                    </a>

                                  </div>
                                </div>
                              </div>
                            </li>

                          </ul>
                        </div>
                        </div>
                      </div>

                      <div class="page-box ">
                        <div class="page-content donation scroll-effect over-y">
                          <div class="list-wrap">
                          <ul>
                            <li>
                              <div class="item-box">
                                <div class="item-head-box">
                                  <div class="subject-box">응원 하기</div>
                                  <div class="donation-box">
                                    '듣고 배우는 한국어'에게 용기와 격려를 보내 주시기 바랍니다.<br/><br/>
                                    <span class="size-80">보내 주시는 성원에 심심<span class="hanja-size">深深</span>한 감사를 드립니다.<br/>
                                      회원 정보가 필요 없이, 누구나 이용을 하실 수 있도록 열어 둔 곳이라서
                                      따로 고마움에 대한 인사 말씀을 드리지 못 할 것입니다.<br/>
                                      이에, 미리 양해의 말씀을 구합니다.</span>
                                  </div>
                                </div>
                              </div>
                            </li>

                            <li>
                              <router-outlet></router-outlet>
                            </li>

                          </ul>
                        </div>


                        </div>
                      </div>

                    </div>


                  </div>

                </div>



              </article>

            </div>

          </div>

    </section>


  </div>


  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>


</div>
